import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { CompanyData } from '../../../types/company-data';
import { EditLicensingOptionsMenuDataProviderFactory } from '../factory/EditLicensingOptionsMenuDataProviderFactory';
import { EditLicensingOptionsMenuBaseDataProvider } from '../dataProvider/EditLicensingOptionsMenuBaseDataProvider';

export class EditLicensingOptionsMenuRepository extends BaseWebComponentRepository {
  public dataProviderFactory: EditLicensingOptionsMenuDataProviderFactory;
  public dataProvider: EditLicensingOptionsMenuBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new EditLicensingOptionsMenuDataProviderFactory(),
    });
  }

  public async getManagedCompanyById(companyId: string): Promise<CompanyData> {
    return this.dataProvider.getManagedCompanyById(companyId);
  }
}
